import React from 'react';

export default class Page3 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">


                                        <div className="ilead-contentarea">
                                            <p>As with any behavioural model, these are guides, not rules.
                                                Nevertheless, most people demonstrate
                                                one or other of these tendencies and don’t alternate between
                                                them easily – learning more
                                                effectively when the method is oriented towards their preferred
                                                style.</p>
                                            <div className="lightgreencontentbg keyquestionpad uiheading">
                                                <p>People who have a clear learning style preference will tend
                                                    to learn more effectively if
                                                    learning is orientated according to their preference.</p>
                                            </div>
                                            <div className="uiheading sept"><p>Next, we’ll outline personality
                                                characteristics which may determine learning styles.</p></div>
                                            <div className="circle_title">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span
                                                    className="heading">PERSONALITY PROFILE – THE BIG FIVE</span>
                                            </div>
                                            <p>There has been much research, over many years, into what
                                                constitutes ‘personality’. Much of it,
                                                however, refers to what is known as the ‘Big Five’
                                                characteristics, around which all aspects of
                                                personality centre. Many studies over the last few decades have
                                                shown the relevance of this form
                                                of profile characterisation to job performance.<a
                                                    className="superscripttext supLinesapce"
                                                    href="further_info.php?course=300"><sup>3</sup></a> The ‘Big
                                                Five’ personality traits are also the basis
                                                of the most widely used personality questionnaires.</p>
                                            <div className="innovativeimg">
                                                <img
                                                    src={require('@images/fiveimg.png')}
                                                    alt=""/>
                                            </div>
                                            <div className="buttonposition">

                                                <div className="left-btn">
                                                    <div
                                                        onClick={this.props.handleChangePage('Page2')}
                                                        className="button-next-previous-done">&lt;&lt; Previous
                                                    </div>
                                                </div>
                                                <div className="right-btn">
                                                    <div
                                                        onClick={this.props.handleChangePage('Page4')}
                                                        className="button-next-previous-done">Next &gt;&gt;</div>
                                                </div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>

                    </div>
                </div>
            </div>
        </div>;
    }
}